import { useState } from "react";

import Container from "@Components/Container";
import * as stylex from "@stylexjs/stylex";

const styles = stylex.create({
    container: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        rowGap: "10px",
    },
});

export function GenerateOnetUrl() {
    const [state, setState] = useState({
        redirectUrl: "/",
        language: "",
    });
    return (
        <Container styleX={styles.container}>
            <input
                type="url"
                onChange={(ev) => setState((s) => ({ ...s, redirectUrl: ev.currentTarget?.value }))}
            ></input>
            <select onChange={(ev) => setState((s) => ({ ...s, language: ev.currentTarget?.value }))}>
                <option value={"pl-PL"}>Polish</option>
                <option value={"en-US"}>English</option>
            </select>
            <a
                href={`https://konto.onet.pl/openid/oauth2/authorize?client_id=openid.goodie.onet.pl.front.onetapi.pl&redirect_uri=https%3A%2F%2F${window.location.host}%2Faccount%2Fexternal-login%2Fonet%2Fsign-in&response_type=code&scope=openid&state=${btoa(JSON.stringify(state))}`}
            >
                Go to onet login
            </a>
        </Container>
    );
}
